import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ResultData } from '../_models/ResultData';
import { AuthHeader } from './../_models/headers';
import { AuthService } from './auth.service';
import { DataUtilService } from './data-util.service';
import { HeaderService } from './header.service';



@Injectable({
  providedIn: 'root'
})
export class SyllabusService {
  aHeader = undefined


  formHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  options = { headers: this.formHeaders }
  public syllabusList=[]
  public responseSubject=new BehaviorSubject<any>({});
  public responseObservable=this.responseSubject.asObservable




  constructor(
      private http: HttpClient,
      private headerService:HeaderService,
      private dataUtilService:DataUtilService,
      private tss:AuthService

  ) {this.aHeader = new AuthHeader(tss)}


  getSyllabusList():Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/syllabus/apiindex`,{headers:this.headerService.bearerJsonHeaders()})

}
getSyllabusListByCurriculum(serverCurriculumId:number):Observable<ResultData> {
  return this.http.get<ResultData>(`${environment.apiUrl}/syllabus/syllabusByCurriculum/${serverCurriculumId}`,{headers:this.headerService.bearerJsonHeaders()})

}
getSyllabusMinDataList() {
  return this.http.get<any>(`${environment.apiUrl}/syllabus/apiminindex`,this.aHeader.openJsonHeaders).pipe(map(
    x=>{
      if(this.dataUtilService.isGoodResponse(x)){
       return this.dataUtilService.myData(x)
      }else{
        return {}
      }
    }
  ))

}

addEditProficiency(formData:string){
  return this.http.post(`${environment.apiUrl}/proficiency/addEdit`, formData, this.aHeader.bearerFormHeaders)
    .pipe(map(data => {
      if(this.dataUtilService.isGoodResponse(data)){
        return this.dataUtilService.myData(data)
      }else{
        return {}
      }
    }));
}



  levelInfo(syllabusCode: string):Observable <ResultData> {
    //const hh = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':`Bearer ${this.tss.getToken()}`})
      return this.http.get<ResultData>(`${environment.apiUrl}/syllabus/apiinfo?lcode=${syllabusCode}`,{headers:this.headerService.bearerJsonHeaders()})


  }

  testSyllabus(syllabusId:number){
    return this.http.get<any>(`${environment.apiUrl}/syllabus/apittesttemps/${syllabusId}`,this.aHeader.openJsonHeaders).pipe(map(
      x=>{
        if(this.dataUtilService.isGoodResponse(x)){
          return this.dataUtilService.myData(x)
         }else{
          return {}
        }
      }
    ))
  }
  getSyllabusById(syllabusId:number){
    return this.http.get<any>(`${environment.apiUrl}/syllabus/apishow/${syllabusId}`,this.aHeader.openJsonHeaders).pipe(map(
      x=>{
        if(this.dataUtilService.isGoodResponse(x)){
          return this.dataUtilService.myData(x)
         }else{
          return {}
        }
      }
    ))
  }
  levelSyllabusDetail(levelId: number):Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/syllabus/syllabusDetailByLevel/${levelId}`,{headers:this.headerService.bearerJsonHeaders()})
  }


  levelInfoDetail(syllabusCode: string) {
    return this.http.get<any>(`${environment.apiUrl}/syllabus/apiinfodetail?lcode=${syllabusCode}`,this.aHeader.openJsonHeaders)
    .pipe(map(x => {
      if(this.dataUtilService.isGoodResponse(x)){
        return this.dataUtilService.myData(x)
       }else{
        return {}
      }
    }))
  }

  removeQuestionTemplate(server_subtopic_id:number,questionTemplateId:number):Observable<ResultData>{
    const h = this.headerService.bearerJsonHeaders()
    return this.http.get<ResultData>(`${environment.apiUrl}/subTopic/removeTemplate/${server_subtopic_id}/${questionTemplateId}`,{headers:h})

  }
  deleteProficiency(proficiency_id:number){
    return this.http.get(`${environment.apiUrl}/proficiency/deleteMe?id=${proficiency_id}`,this.aHeader.bearerJsonHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }else{
          return {}
        }

      }));
}

removeProficiencyTemplate(proficiency_id:number,server_task_template_id:number){
  return this.http.get(`${environment.apiUrl}/proficiency/removeTemplate?id=${proficiency_id}&server_task_template_id=${server_task_template_id}`,this.aHeader.bearerJsonHeaders)
    .pipe(map(data => {
      if(this.dataUtilService.isGoodResponse(data)){
        return this.dataUtilService.myData(data)
      }else{
        return {}
      }

    }));
}
getSyllabusInfo(serverStudentUserId: number):Observable<ResultData> {

  return this.http.get<ResultData>(`${environment.apiUrl}/student/syllabus/${serverStudentUserId}`,{headers:this.headerService.bearerJsonHeaders()})

}

getGroupSyllabusInfo(server_subscription_grouping_id: number) {

  return this.http.get<any>(`${environment.apiUrl}/subscriptionGrouping/syllabus/${server_subscription_grouping_id}`).pipe(map(data => {
    let student:any= {}
    if(this.dataUtilService.isGoodResponse(data)){
      student= this.dataUtilService.myData(data)
    }

    return student
  }))
}
}
